const theme = require('./theme.json');

const CHART_COLORS = [
  theme.chartColor1,
  theme.chartColor2,
  theme.chartColor3,
  theme.chartColor4,
  theme.chartColor5,
  theme.chartColor6,
  theme.chartColor7,
  theme.chartColor8,
  theme.chartColor9,
  theme.chartColor10,
  theme.chartColor11,
  theme.chartColor12,
  theme.chartColor13,
];

const STATIC_SEGMENT_COLOR = {
  dark: theme.segmentColor1,
  light: theme['segmentColor1-light'],
};

const SEGMENT_COLORS = [
  [theme.segmentColor2, theme['segmentColor2-light']],
  [theme.segmentColor3, theme['segmentColor3-light']],
  [theme.segmentColor4, theme['segmentColor4-light']],
  [theme.segmentColor5, theme['segmentColor5-light']],
  [theme.segmentColor6, theme['segmentColor6-light']],
];

const GRADE_COLORS = {
  1: theme.veryBad,
  2: theme.bad,
  3: theme.neutral,
  4: theme.good,
  5: theme.veryGood,
};

const BENCHMARK_COLORS = [
  theme.bechmarkColor1,
  theme['bechmarkColor1-light'],
];

const DEPENDENCY_COLORS = [
  theme.dependencyColor1,
  theme.dependencyColor2,
  theme.dependencyColor3,
  theme.dependencyColor4,
  theme.dependencyColor5,
  theme.dependencyColor6,
  theme.dependencyColor7,
  theme.dependencyColor8,
  theme.dependencyColor9,
];

const BLACK = theme.black;
const WHITE = theme.white;

function getColorMix(Color, startColor, endColor, value, min, max) {
  const color = Color(startColor);
  if (value == null || min == null || max == null || max - min === 0) {
    return color.hex();
  }

  return color.mix(Color(endColor), (value - min) / (max - min)).hex();
}

function getSegmentDateRangeColor(Color, segmentIndex, dateRangeIndex, dateRangeCount) {
  if (segmentIndex === -1) {
    return getColorMix(
      Color,
      STATIC_SEGMENT_COLOR.dark,
      STATIC_SEGMENT_COLOR.light,
      dateRangeIndex,
      0,
      dateRangeCount - 1,
    );
  }

  const colorIndex = segmentIndex % SEGMENT_COLORS.length;
  return getColorMix(
    Color,
    SEGMENT_COLORS[colorIndex][0],
    SEGMENT_COLORS[colorIndex][1],
    dateRangeIndex,
    0,
    dateRangeCount - 1,
  );
}

function getBenchmarkColor(Color, segmentIndex, segmentTotal) {
  return getColorMix(
    Color,
    BENCHMARK_COLORS[0],
    BENCHMARK_COLORS[1],
    segmentIndex,
    0,
    segmentTotal,
  );
}

const takenDependencyColors = {};
function nextDependencyColor() {
  const index = Object.keys(takenDependencyColors).length % DEPENDENCY_COLORS.length;
  return DEPENDENCY_COLORS[index];
}

function getDependencyColor(id) {
  if (takenDependencyColors[id]) {
    return takenDependencyColors[id];
  }

  takenDependencyColors[id] = nextDependencyColor();
  return takenDependencyColors[id];
}

module.exports = {
  CHART_COLORS,
  STATIC_SEGMENT_COLOR,
  SEGMENT_COLORS,
  GRADE_COLORS,
  BENCHMARK_COLORS,
  BLACK,
  WHITE,
  getColorMix,
  getSegmentDateRangeColor,
  getBenchmarkColor,
  getDependencyColor,
};
